import React from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Collapse, Container, Form, Input, Label, Media, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import ModalEnsamble from "../../components/ModalPersonalizado/ModalEnsamble"
import _valid from "../../validations"
import { MDBBtn, MDBIcon } from "mdbreact";


export default class formularioEnsamble extends React.Component {
    constructor(props) {
        super(props);

        this.apiRest = new ApiRest(props);

        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {

            },
            colapsar: true,
        };

    }

    componentDidMount() {
        //console.log(this.state.registro);
    }

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    render() {
        const {
            registro,
            colapsar,
        } = this.state;

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Formulario" breadcrumbItem="Ensamble" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsar()} className="text-dark" to="#">
                                            <div className="p-4">
                                                <Media className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <i className="uil uil-receipt text-primary h2"></i>
                                                    </div>
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Enviar a ensamble/Almacen</h5>
                                                        <p className="text-muted text-truncate mb-0">Por favor, proporciona los datos.</p>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <Collapse isOpen={colapsar}>
                                            <Form>
                                                <Row>
                                                    <Col lg={12}>
                                                        <ModalEnsamble registro={registro} props={this.props} />
                                                    </Col>
                                                    <Col lg={12} className="text-end">
                                                        <MDBBtn className="waves-effect" color="warning" onClick={() => { this.props.history.replace('/listaActivosEnsamble') }}>
                                                            <MDBIcon icon="fas fa-arrow-left" /> {' '}
                                                            Regresar
                                                        </MDBBtn>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                    </Container>
                </div>

            </React.Fragment>
        );
    }
}